import { render } from "./depositBonus.vue?vue&type=template&id=22413f0e&scoped=true"
import script from "./depositBonus.vue?vue&type=script&lang=js"
export * from "./depositBonus.vue?vue&type=script&lang=js"

import "./depositBonus.vue?vue&type=style&index=0&id=22413f0e&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22413f0e"]])

export default __exports__